import { render, staticRenderFns } from "./base-button-icon.vue?vue&type=template&id=40608f80&scoped=true&"
import script from "./base-button-icon.vue?vue&type=script&lang=ts&"
export * from "./base-button-icon.vue?vue&type=script&lang=ts&"
import style0 from "./base-button-icon.vue?vue&type=style&index=0&id=40608f80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40608f80",
  null
  
)

export default component.exports